import type { TypePublic } from "@/features/domaine/types/opco"
import type { TypeEntiteJuridique, TypeEntreprise } from "./HabilitationDTO"
import type { StatutHabilitation } from "@/features/domaine/types/opco/Permissions/StatutHabilitation"

export type HabilitationAddDTO = {
  userId: string
  typeEntreprise: TypeEntreprise
  typeEntiteJuridique: TypeEntiteJuridique
  identifiantEntiteJuridique: string
  publics: { type: TypePublic }[]
  statut: StatutHabilitation
}

export class HabilitationAddErreurDoublon extends Error { }
